export * from './promo-banner.graphql'
